module.exports = __webpack_public_path__ + "img/partner-yukmanjat.e96571e0.png";